// SideBar.js

import React from 'react';
import './sidebar.css'; // Custom CSS
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { logoutService } from '../../redux/services/authService';
import { logout } from '../../redux/auth/authSlice';
import { sidebarLinks } from '../../consts/consts'; // Import sidebar links
import { clearInvestmentData } from '../../redux/project/investmentSlice';

export default function SideBar() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const navigateTo = (path: string) => {
    navigate(path);
  };

  const handleLogout = async () => {
    dispatch(clearInvestmentData());
    dispatch(logout());
  };
  const selectedRoute = window.location.pathname;

  return (
    <div className="col-12 col-md-3 col-lg-2 bg-light vh-91 p-3 shadow-sm d-flex flex-column sticky-sidebar">
      <nav className="d-flex flex-column flex-grow-1">
        {sidebarLinks.map((item) => (
          <span
            className={`sidebar-link ${selectedRoute === item.link ? 'active' : ''}`}
            key={item.link} // Add a unique key for list items
            onClick={() => navigateTo(item.link)}
          >
            {item.title}
          </span>
        ))}
        <div className="mt-auto">
          <span className="sidebar-link" onClick={handleLogout}>
            Logout
          </span>
        </div>
      </nav>
    </div>
  );
}
